import React from "react";
import Footer from "./Footer";

class WelcomeLayer extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      logo: this.props.logo,
      footer: this.props.footer
    }
  }

  render() {
    return (
      <div className="card card-signin my-5 col-sm-6 border-left-0 " style={{background: this.props.background}} >
        <img alt="ciber" className="justify-content-center align-self-center" style={{maxWidth:"300px", paddingTop:"10%"}}
          src={this.props.logo} onError={({ currentTarget }) => {
          currentTarget.onerror = null;
          currentTarget.src="https://webpage.cibercolegios.com/images/logos/logo.png";
        }}/>.
        <div className="card-body align-self-center">
            <h2 className="card-title row justify-content-center align-self-center text-white institution-font">¡Bienvenido!</h2>
            {this.props.message?
              <h6 className="justify-content-justify text-white text-justify institution-font">{this.props.message} {this.props.mail}</h6>
        :<></>}
        </div>
        <Footer footer={this.state.footer}/>
      </div>

    )
  }
}

export default WelcomeLayer;
